import { Injectable } from '@angular/core';
import { ErrorHandlerService } from '@inera/common';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { NotificationService } from '../../service/notification.service';
import { ApiMessage } from './model/api-message';

@Injectable()
export class SithsEidErrorHandlerService extends ErrorHandlerService {
  constructor(
    private notificationService: NotificationService,
    private router: Router
  ) {
    super();
  }

  public error(error: any): Observable<never> {
    const message: ApiMessage = {
      message: '',
      title: ''
    };

    switch (error.status) {
      case 400:
        message.title = 'Felaktigt anrop';
        message.message = 'Anropet till tjänsten är felaktigt formaterad.';
        break;
      case 401:
        if (error.error && error.error.message === 'No HTTP session') {
          this.router.navigate(['login']);
          message.title = 'Session utgången';
          message.message = 'Sessionen har gått ut.';
        } else {
          message.title = 'Otillåten åtkomst';
          message.message = 'Du har inte behörighet att hämta resursen.';
        }
        break;
      case 403:
        message.title = 'Åtkomst förbjuden';
        message.message = 'Resursen kan inte hämtas utan korrekt inloggning.';
        break;
      case 404:
        message.title = 'Finns ej';
        message.message = 'Resursen finns inte eller kunde inte hittas.';
        break;
      case 422:
        message.title = 'Inkorrekt data';
        break;
      case 500:
        message.title = 'Oväntat fel';
        message.message = 'Någonting gick fel i anropet, vänligen försök igen.';
        break;
      default:
        message.title = 'Något gick fel';
        message.message = 'Någonting gick fel i anropet, vänligen försök igen.';
    }

    if (error.error && error.error.title) {
      message.title = error.error.title;
    }

    if (error.error && error.error.messages && error.error.messages.length > 0) {
      message.message = error.error.messages;
    }

    if (error.status === 422) {
      this.notificationService.warning(message.message, message.title);
    } else {
      this.notificationService.error(message.message, message.title);
    }

    return throwError(error);
  }
}
